import { SelectOption } from 'components/Forms';
import { TypeInsurancesAcceptedFields } from 'types/contentful';
import ContentService from 'utils/contentful/contentfulService';
import { StateAbbrev } from 'utils/states';

export const NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION: SelectOption = {
  label: 'Other',
  value: 'other',
};

export const getAcceptedInsuranceOptions = async (stateCode: StateAbbrev): Promise<SelectOption[]> => {
  return ContentService.clients.expressable
    .getEntries<TypeInsurancesAcceptedFields>({
      content_type: 'insurancesAccepted',
      'fields.stateCode[match]': stateCode,
    })
    .then(({ items }) => {
      if (items.length !== 1) {
        throw new Error(`No medicaid providers found for state code ${stateCode} (found ${items.length} entries)`);
      } else {
        return items[0];
      }
    })
    .then(({ fields: { insurances } }) => {
      if (!insurances) {
        throw new Error(`Empty insurance list from contentful, state code ${stateCode}`);
      }
      const options: SelectOption[] = insurances.map(insurance => ({
        label: insurance,
        value: insurance,
      }));

      options.push(NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION);
      return options;
    });
};
